<template>
  <div class="forumMainList" @mouseenter="mouseEnter" @mouseleave="mouseLeave">
    <ModuleNav :normal="nav.normal" :hover="nav.hover" :isInModule="isInModule" />
    <div class="content">
      <div class="day">
        <div class="left">
          <ForumDescription :image="daysInfo[0].image" :brief="daysInfo[0].brief" />
        </div>
        <div class="pure-right" style="width: 178vh;margin-left: 5vh;">
          <img
            src="https://summit-img.geekpark.net/gpk-meeting-module/4-2-4-%E6%97%A5%E7%A8%8B%E4%BB%8B%E7%BB%8D-%E5%9B%BE%E7%89%87%E4%BB%8B%E7%BB%8D.jpg"
            style="height: 100vh; "
          />
        </div>
      </div>
      <div class="day">
        <div class="left">
          <ForumDescription :image="daysInfo[1].image" :brief="daysInfo[1].brief" />
        </div>
        <div class="right" style="width: 120vh">
          <div class="item" v-for="(item,index) in scheduleFirst" :key="index">
            <div class="item-content">
              <div class="head">
                <span class="time">{{item&&item.start_at | parseTime}}</span>
                <img
                  src="https://summit-img.geekpark.net/ifx/images/%E5%B0%8F%E4%BC%97%E4%B8%8E%E5%A4%A7%E4%BC%97.svg"
                  style="height: 2.2vh;"
                  v-if="item&&item.description === '小众与大众'"
                />
                <img
                  src="https://summit-img.geekpark.net/ifx/images/%E7%AA%81%E7%A0%B4%E4%B8%8E%E4%BC%A0%E6%89%BF.svg"
                  style="height: 2.2vh;"
                  v-if="item&&item.description === '突破与传承'"
                />
                <img
                  src="https://summit-img.geekpark.net/ifx/images/%E8%99%9A%E6%8B%9F%E4%B8%8E%E7%8E%B0%E5%AE%9E.svg"
                  style="height: 2.2vh;"
                  v-if="item&&item.description === '虚拟与现实'"
                />
                <img
                  src="https://summit-img.geekpark.net/ifx/images/%E7%A7%91%E6%8A%80%E4%B8%8E%E4%BA%BA%E6%80%A7.svg"
                  style="height: 2.2vh;"
                  v-if="item&&item.description === '科技与人性'"
                />
                <img
                  src="https://summit-img.geekpark.net/ifx/images/%E4%BA%BA%E5%B7%A5%E6%99%BA%E8%83%BD%E4%B8%8E%E4%BA%BA.svg"
                  style="height: 2.2vh;"
                  v-if="item&&item.description === '人工智能与人'"
                />
                <img
                  src="https://summit-img.geekpark.net/ifx/images/%E4%BC%A0%E7%BB%9F%E4%B8%8E%E5%88%9B%E6%96%B0.svg"
                  style="height: 2.2vh;"
                  v-if="item&&item.description === '传统与创新'"
                />
              </div>
              <h2>{{item&&item.title}}</h2>
              <div v-if="item&&item.image" style="position: absolute; bottom: 2vh;text-align: left">
                <img :src="item&&item.image" style="width: 70%;vertical-align: bottom;" />
              </div>
              <div class="guest" v-if="item&&item.guests.length > 0">
                <img :src="item&&item.guests[0].avator.url" alt />
                <div class="guest-info">
                  <h2>{{item&&item.guests[0].company}}</h2>
                  <p>{{item&&item.guests[0].name}}</p>
                  <p>{{item&&item.guests[0].title}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="day">
        <div class="left">
          <ForumDescription :image="daysInfo[2].image" :brief="daysInfo[2].brief" />
        </div>
        <div class="right" style="width: 120vh">
          <div class="item" v-for="(item,index) in scheduleSecond" :key="index">
            <div class="item-content">
              <div class="head">
                <span class="time">{{item&&item.start_at | parseTime}}</span>
                <img
                  src="https://summit-img.geekpark.net/ifx/images/%E5%B0%8F%E4%BC%97%E4%B8%8E%E5%A4%A7%E4%BC%97.svg"
                  style="height: 2.2vh;"
                  v-if="item&&item.description === '小众与大众'"
                />
                <img
                  src="https://summit-img.geekpark.net/ifx/images/%E7%AA%81%E7%A0%B4%E4%B8%8E%E4%BC%A0%E6%89%BF.svg"
                  style="height: 2.2vh;"
                  v-if="item&&item.description === '突破与传承'"
                />
                <img
                  src="https://summit-img.geekpark.net/ifx/images/%E8%99%9A%E6%8B%9F%E4%B8%8E%E7%8E%B0%E5%AE%9E.svg"
                  style="height: 2.2vh;"
                  v-if="item&&item.description === '虚拟与现实'"
                />
                <img
                  src="https://summit-img.geekpark.net/ifx/images/%E7%A7%91%E6%8A%80%E4%B8%8E%E4%BA%BA%E6%80%A7.svg"
                  style="height: 2.2vh;"
                  v-if="item&&item.description === '科技与人性'"
                />
                <img
                  src="https://summit-img.geekpark.net/ifx/images/%E4%BA%BA%E5%B7%A5%E6%99%BA%E8%83%BD%E4%B8%8E%E4%BA%BA.svg"
                  style="height: 2.2vh;"
                  v-if="item&&item.description === '人工智能与人'"
                />
                <img
                  src="https://summit-img.geekpark.net/ifx/images/%E4%BC%A0%E7%BB%9F%E4%B8%8E%E5%88%9B%E6%96%B0.svg"
                  style="height: 2.2vh;"
                  v-if="item&&item.description === '传统与创新'"
                />
              </div>
              <h2>{{item&&item.title}}</h2>
              <div v-if="item&&item.image" style="position: absolute; bottom: 2vh;text-align: left">
                <img :src="item&&item.image" style="width: 70%;vertical-align: bottom;" />
              </div>
              <div class="guest" v-if="item&&item.guests.length > 0">
                <img :src="item&&item.guests[0].avator.url" alt />
                <div class="guest-info">
                  <h2>{{item&&item.guests[0].company}}</h2>
                  <p>{{item&&item.guests[0].name}}</p>
                  <p>{{item&&item.guests[0].title}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ForumDescription from "./ForumDescription";
import ForumGuests from "./ForumGuests.vue";
import ModuleNav from "./ModuleNav";
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "ForumMainList",
  components: {
    ModuleNav,
    ForumGuests,
    ForumDescription
  },
  data() {
    return {
      isInModule: false
    };
  },
  computed: {
    ...mapState({
      nav: state => state.forumMainList.nav,
      daysInfo: state => state.forumMainList.daysInfo
    }),
    scheduleFirst() {
      let tempSchedule =
        this.$store.state.global.vice_activities[0] &&
        this.$store.state.global.vice_activities[0].speeches[0].speeches;
      if (tempSchedule) {
        tempSchedule.slice().sort((prev, next) => {
          return (
            moment(prev.start_at).valueOf() - moment(next.start_at).valueOf()
          );
        });
      }
      return tempSchedule;
    },
    scheduleSecond() {
      let tempSchedule =
        this.$store.state.global.vice_activities[1] &&
        this.$store.state.global.vice_activities[1].speeches[0].speeches;
      if (tempSchedule) {
        tempSchedule.slice().sort((prev, next) => {
          return (
            moment(prev.start_at).valueOf() - moment(next.start_at).valueOf()
          );
        });
      }
      return tempSchedule;
    }
  },
  methods: {
    mouseEnter() {
      this.isInModule = true;
    },
    mouseLeave() {
      this.isInModule = false;
    }
  },
  filters: {
    parseTime: function(date) {
      if (moment(date).hours() < 12) {
        return moment(date).format("hh:mm") + " AM";
      } else {
        return moment(date).format("hh:mm") + " PM";
      }
    }
  }
};
</script>

<style scoped lang="less">
.forumMainList {
  display: flex;
  height: 100vh;
  margin-left: 5vh;
}

.content {
  display: flex;
  margin-left: 5vh;

  > div {
    height: 100%;
    box-sizing: border-box;
  }
}

.day {
  padding: 5vh 0;
  display: flex;

  &:not(:last-of-type) {
    margin-right: 5vh;
  }

  .left {
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    align-items: flex-start;
    width: 60vh;
    height: 90vh;
    position: relative;
  }

  .pure-right {
    align-self: center;
    display: flex;
  }

  .right {
    display: flex;
    justify-content: space-between;
    align-self: center;
    flex-wrap: wrap;
    height: 86vh;
    transform: translateY(-1vh);

    .item {
      display: flex;
      box-sizing: border-box;
      width: 40vh;
      height: 22vh;
      padding: 1vh;
      background-clip: content-box;
      background-color: #f9f9f9;

      .item-content {
        width: 100%;
        height: 100%;
        position: relative;
        padding: 1vh 1.8vh 0 1.8vh;

        .head {
          width: 100%;
          display: flex;
          justify-content: space-between;
          font-size: 2.5vh;
          font-weight: 800;

          .time {
            color: #ff3c00;
            font-family: SyncopateBold;
          }
        }

        > h2 {
          margin-top: 0.8vh;
          line-height: 1.2;
          text-align: left;
          font-size: 1.85vh;
        }

        .guest {
          display: flex;
          justify-content: flex-start;
          position: absolute;
          bottom: 1vh;
          width: 100%;
          text-align: left;

          img {
            width: 9.2vh;
            height: 9.2vh;
            border-radius: 4.6vh;
          }

          .guest-info {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            margin-left: 2.5vh;
            padding: 0.4vh 0;
            font-size: 1.8vh;

            h2 {
              color: #ff3c00;
              font-size: 2.2vh;
            }

            p {
              white-space: nowrap;

              &:last-child {
                color: #535353;
              }
            }
          }
        }

        .guest0,
        .guest1,
        .guest2,
        .guest3 {
          .guest;
          width: 8.4vh;
          height: 8.4vh;

          > .guest-info {
            display: none;
          }

          > img {
            width: 8.4vh;
            height: 8.4vh;
          }
        }

        .guest1 {
          left: 28%;
        }

        .guest2 {
          left: 51%;
        }

        .guest3 {
          left: 75%;
        }

        .guest-hover {
          width: 100%;
          left: 4.5%;
          transition: left 0.3s linear;

          > .guest-info {
            display: flex;
            visibility: visible;
          }
        }
      }
    }
  }
}
</style>
